import { Injectable } from "@angular/core";
import { PruHttpService } from "../../services/pru-http.service";

@Injectable()
export class TooltipService {
  tooltipContent: string =
    "Please refer to your contract for details about this particular field.";
  constructor(private PruHTTP: PruHttpService) {}

  getTooltipWcmUrl(definitionID, definitionLocation, clickTitle) {
    return (
      "/wps/wcm/myconnect/" +
      definitionLocation +
      "/" +
      clickTitle +
      "?source=library&srv=cmpnt&cmpntname=UCD_Design/MENU-Help&sitearea=" +
      definitionLocation +
      "/" +
      clickTitle +
      "&codes=" +
      definitionID
    );
  }

  getTooltipData(serviceURL: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.PruHTTP.getText(serviceURL, "TooltipService").subscribe(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }
}
